module.exports = __webpack_public_path__ + "static/media/Avatar4b.8afb2b5f.png";